import { IFieldModel } from '@checkout/fields';
import { IAddressFields } from '@checkout/state';
import { FocusEvent } from 'react';
import { IntlProvider } from 'react-intl';
import messages from '../../../i18n/base-en';
import { email, minLength, required } from '../../../utils/validators';
import { InputField, IntlTelField } from '../../presentational';
import { ICheckoutContextConfig } from './../../../config/contextCheckoutConfig.d';

export const getContactDetailsFormModel = (
    fields: IAddressFields,
    formName: string,
    intlData: IntlProvider.Props,
    checkoutContextConfig: ICheckoutContextConfig,
    isEmailDisabled: boolean,
    handleEmailBlur?: (event: FocusEvent<any>) => void) => {
  const { intl } = new IntlProvider({ ...intlData }, {}).getChildContext();
  const { formatMessage } = intl;

  const addersFormModel: IFieldModel[] = [
    {
      component: InputField,
      type: 'email',
      name: 'email',
      placeholder: formatMessage(messages.email_placeholder),
      label: formatMessage(messages.email_label),
      required: fields.email.required,
      visible: fields.email.visible,
      disabled: isEmailDisabled,
      onBlur: handleEmailBlur,
      validate: (value: string) => {
        let error;
        const requiredError = required(value, formatMessage(messages.required_valid_error));
        const minLengthError = minLength(value, 6, formatMessage(messages.min_length_error, { min: 6 }));
        const emailError = email(value, formatMessage(messages.email_valid_error));

        if (fields.email.required && requiredError) {
          error = requiredError;
        } else if (minLengthError) {
          error = minLengthError;
        } else if (emailError) {
          error = emailError;
        }

        return error;
      },
      sizeVariant: checkoutContextConfig.ui.intlTelInput.isEnabled ? 'half' : 'medium',
    },
    {
      component: checkoutContextConfig.ui.intlTelInput.isEnabled ? IntlTelField : InputField,
      type: 'tel',
      name: 'phoneNumber',
      placeholder: formatMessage(messages.phone_number_placeholder),
      label: formatMessage(messages.phone_number_label),
      required: fields.phoneNumber.required,
      visible: fields.phoneNumber.visible,
      validate: (value: string) => {
        let error;
        const requiredError = required(value, formatMessage(messages.required_valid_error));
        const minLengthError = minLength(value, 6, formatMessage(messages.min_length_error, { min: 6 }));

        if (fields.phoneNumber.required && requiredError) {
          error = requiredError;
        } else if (minLengthError) {
          error = minLengthError;
        }

        return error;
      },
      sizeVariant: checkoutContextConfig.ui.intlTelInput.isEnabled ? 'half' : 'small',
    },
  ];

  return addersFormModel;
};
